import noAdImage from "../../../assetsStatic/NoAd.png";

const InitialAdState = () => {
  return (
    <>
      <div className='initialNoadvert'>
        <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710424127/static%20images%20storelens/NoAd_on6elg.png"} />
        <h3>
          Reach new customers by advertising <br /> your products{" "}
        </h3>
        <p>
          Create an ad that makes it easier for <br /> customers to find your store{" "}
        </p>
      </div>
    </>
  );
};

export default InitialAdState;
